import {UserVo} from '../../common/shared/api/nicolas/vo/UserVo.interface';
import {User} from '../generated/types';
import {createUserState} from './UserState';
import {createUserType} from './UserType';

export function createUser({
  userVo,
  age,
  authenticatedAt,
}: {
  userVo: UserVo;
  age?: number;
  authenticatedAt?: string;
}): User {
  return {
    uid: String(userVo.uid),
    userId: userVo.user_id,
    kakaoAccountId: userVo.account_id,
    state: createUserState(userVo.status),
    type: createUserType(userVo.type),
    thumbnail: userVo.profile_thumbnail_url,
    appUserId: userVo.app_user_id,
    nickname: userVo.nickname,
    email: userVo.email,
    needProfileUpdate: userVo.need_profile_update === 'Y',
    age,
    authenticatedAt,
  };
}
